import { registerMockAPI } from '~/mocks/mockApis';

import { useMutation } from '@tanstack/react-query';

import { axiosInstance } from '~/services';

import { API_ENDPOINT } from '~/constants';

import type {
  TypeApiResponse,
  TypePutReceivingLabelLabelsParams,
  TypePutReceivingLabelLabelsResponse,
} from '~/types/receive.types';

type LabelParams = {
  ownerCode: string;
  params: TypePutReceivingLabelLabelsParams;
};

/**
 * [입고요청관리] 라벨 출력 API
 */
const fetchPutReceivingLabelLabels = async ({ ownerCode, params }: LabelParams) => {
  const { data } = await axiosInstance.put<TypeApiResponse<TypePutReceivingLabelLabelsResponse['data']>>(
    `${API_ENDPOINT.RECEIVE_2.PUT_RECEIVING_LABEL_LABELS}/${ownerCode}/labels`,
    params
  );
  return data.data;
};

/**
 * [입고요청관리] 라벨 출력 Mutation Hook
 * @description 에러 처리는 사용처에서 개별 처리 (dialog 표시)
 */
export const usePutReceivingLabelLabelsMutation = () => {
  return useMutation({
    mutationFn: fetchPutReceivingLabelLabels,
    meta: { showGlobalErrorToast: false },
  });
};

registerMockAPI<TypePutReceivingLabelLabelsResponse>({
  method: 'put',
  endpoint: '/api-inbound/v1/kls/receiving-label/:ownerCode/labels',
  label: '입고/입고요청/라벨출력',
  scenarios: [
    {
      name: '정상 응답 (라벨 1건)',
      response: {
        data: {
          labels: [
            {
              receivingRequestCode: 'IB20250107000001',
              receivingWarehouseName: 'GPM1',
              inboundAreaName: '센소',
              receivingExpectedDate: '2025-01-07',
              ownerCode: 'CU000001',
              ownerName: '3PL 수신 테스트',
              supplierCode: 'SU000013',
              supplierName: '테스트공급사',
              expirationDate: '2025-09-06',
              totalBoxCnt: 10,
              unitPerBox: 10,
              totalUnit: 100,
              goodsName: '(센터명)화주사상품',
              deliveryType: '냉장',
              putawayZone: 'A-01',
              goodsCode: 'M00000107605',
              alternativeCode: '8812312312012',
              isQi: false,
            },
          ],
        },
      },
    },
    {
      name: '서버 오류',
      response: {
        error: {
          code: 9999,
          message: '라벨 출력에 실패했습니다.\n다시 시도해주세요.',
        },
      },
      status: 500,
    },
  ],
});
